<template>
  <div class="login-mail-auth">
    <div
      class="form-window">
      <div
        class="form-title"
        v-html="sanitizedContent(formTitle)" />
      <MdtInput
        ref="code"
        v-model="code"
        :label="'admin_enter_code' | translate"
        :placeholder="'general_code' | translate"
        required
        @keyupEnter="mailNumberAuth" />
      <div
        class="btn btn-primary button-mail-auth"
        @click="mailNumberAuth">
        {{ 'general_confirm' | translate }}
      </div>
      <div class="resend-code">
        <div>
          {{ 'admin_didnt_get_code' | translate }}
        </div>
        <div
          class="btn btn-label theme button-resend-auth-code"
          @click="resendMailAuthCode">
          {{ 'general_send_again' | translate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login2FaEmailAuth',
  props: {
    loginData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      code: '',
      loading: false,
      resendCodeLoading: false,
    };
  },
  computed: {
    formTitle() {
      const { translate } = this.$options.filters;
      const value = `<br><span>${this.loginData.email}</span>`;
      return translate('admin_auth_code_email_message').replace('[d]', value);
    },
  },
  methods: {
    mailNumberAuth() {
      if (!this.$refs.code.isValid()) return;

      const args = {
        username: this.loginData.name,
        password: this.loginData.password,
        email_2fa_code: this.code,
      };

      this.loading = true;
      this.$store.dispatch('auth/twoFaLogin', args)
        .then(() => {
          const { redirect } = this.$route.query;
          this.$router.push(redirect || '/');
        }).catch((err) => {
          this.showResponseError(err);
          this.loading = false;
        });
    },
    resendMailAuthCode() {
      if (this.resendCodeLoading) return;

      const args = {
        username: this.loginData.name,
        password: this.loginData.password,
      };

      this.resendCodeLoading = true;
      this.$store.dispatch('auth/login', args).then((data) => {
        this.$store.dispatch('notify', data.notify);
      }).catch(this.showResponseError)
        .finally(() => {
          this.resendCodeLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-window {
  width: 100%;
  max-width: 315px;
  padding: 0 0 40px 0;
  margin: 0px auto 0 auto;
  border-radius: 8px;
  border-color: $border-light-color;
  color: $color-text-secondary;

  .form-title {
    margin-bottom: 32px;
  }

  .form-title {
    ::v-deep span {
      font-weight: bold;
      color: $color-text-primary;
    }
  }

  > .mdt-input {
    margin-bottom: 30px;
  }

  .resend-code {
    margin-top: 30px;

    .btn-label {
      margin-top: 5px;
      padding: 5px 5px 5px 0;
    }
  }
}
</style>
